import React, { Component } from "react";
import logo from "../../images/logo-dark.png";
import { APP_CONFIG } from "../../AppConfig";
import { Link } from "react-router-dom";
import AuthService from "../../Auth";
import { Auth } from "aws-amplify";
import "./Login.css";

function Login () {
  const handleLogin=() =>{
    const url = new URL(window.location.href);
    const baseUrl = `${url.protocol}//${url.host}`;
    const encodedRedirectUrl = encodeURIComponent(baseUrl);
    window.location.href = `${APP_CONFIG.SIGNIN_URL}/?redirect_url=${encodedRedirectUrl}`
  }
    return (
      <div className="main-wrapper account-wrapper">
        <div className="account-page">
          <div className="account-center">
            <div className="account-box">
              <div className="account-logo">
                <img src={logo} alt="" />
              </div>

              <h2>Secure Login Required</h2>
              <div className="text">
                To ensure the security and privacy of our site and its users,
                access is restricted to authorized personnel only.
                <div className="text-center">Please log in to continue.</div>
              </div>

              <div className="form-group text-center">
                <button
                  type="submit"
                  className="btn btn-primary account-btn"
                  // onClick={() => Auth.federatedSignIn()}
                  onClick={() => handleLogin()}
                >
                  Login
                </button>
              </div>
              <div className="text-center register-link">
                Don’t have an account? Contact Administrator
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
export default Login;
